import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import type { FieldStats } from '../../types/benchmark';

interface FieldAccuracyChartProps {
  fields: FieldStats[];
}

export function FieldAccuracyChart({ fields }: FieldAccuracyChartProps) {
  // Sort by precision descending
  const sortedFields = [...fields].sort((a, b) => b.precision - a.precision);

  // Get color based on precision value
  const getBarColor = (precision: number) => {
    if (precision >= 0.95) return '#10b981'; // green
    if (precision >= 0.85) return '#fbbf24'; // yellow
    if (precision >= 0.70) return '#f97316'; // orange
    return '#ef4444'; // red
  };

  return (
    <div className="bg-white p-6 border rounded-lg">
      <h3 className="text-lg font-semibold mb-4">Précision par champ</h3>

      <ResponsiveContainer width="100%" height={400}>
        <BarChart
          data={sortedFields}
          layout="vertical"
          margin={{ top: 5, right: 30, left: 150, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" domain={[0, 1]} tickFormatter={(value) => `${(value * 100).toFixed(0)}%`} />
          <YAxis type="category" dataKey="field" width={140} />
          <Tooltip
            formatter={(value) => typeof value === 'number' ? `${(value * 100).toFixed(1)}%` : value}
            labelFormatter={(label) => `Champ: ${label}`}
          />
          <Bar dataKey="precision" radius={[0, 4, 4, 0]}>
            {sortedFields.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={getBarColor(entry.precision)} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
